const prefix = 'PAYMENT/';
export const SET = prefix + 'SET';
export const SET_CARD = prefix + 'SET_CARD';
export const RESET = prefix + 'RESET';
